import './avatar.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { ICON_TYPE } from 'components/icon';

const initialsFromName = (name) => {
  if (!name) {
    return null;
  }

  const words = name.trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return null;
  }

  return words
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
};

/**
 * Circular user avatar. Renders the served WebP variants when the user has an
 * avatar, otherwise falls back to initials (or the generic avatar icon).
 */
const UserAvatar = (props) => {
  const size = { width: props.size, height: props.size };

  if (props.avatarUrl) {
    return (
      <img
        className={classNames('user-avatar', props.className)}
        style={size}
        src={props.avatarUrl}
        srcSet={props.avatarUrl2x ? `${props.avatarUrl2x} 2x` : undefined}
        alt={props.name || 'User avatar'}
      />
    );
  }

  const initials = initialsFromName(props.name);

  return (
    <span
      className={classNames('user-avatar', 'user-avatar-fallback', props.className)}
      style={{ ...size, fontSize: Math.round(props.size * 0.38) }}
    >
      {initials || <Icon type={ICON_TYPE.AVATAR} />}
    </span>
  );
};

UserAvatar.propTypes = {
  name: PropTypes.string,
  avatarUrl: PropTypes.string,
  avatarUrl2x: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};

UserAvatar.defaultProps = {
  size: 96,
};

export default UserAvatar;
